<template>
  <div>
    <section>
      <h2>ダウンロードテスト</h2>
      <button class="btn" @click="download">ダウンロードテスト</button>
    </section>

    <section>
      <h2>Participant List</h2>
      <ul style="display: flex; justify-content: left">
        <li v-for="(participant, id) in this.$store.getters['participants/all']" :key="id" class="participant">
          <img :src="participant.avatar" style="height: 64px; width: 64px; margin-right: 16px" />
          <p>
            id: {{ participant.id }}
            <fa-icon class="fa-open" icon="external-link-alt" @click="showDMModal(id)" />
            <br />
            名前: {{ participant.name }}<br />
            所属: {{ participant.organization }}<br />
            区分: {{ participant.isAdmin ? "管理者" : "ゲスト" }}<br />
            場所: {{ participant.where || "指定なし" }}
            <fa-icon class="fa-open" icon="external-link-alt" @click="showMoveModalFn(participant)" />
            <br />
          </p>
        </li>
      </ul>
    </section>

    <section>
      <h2>Direct Messages</h2>

      <label>User</label>
      <select v-model="userId">
        <option v-for="(participant, id) in this.$store.getters['participants/all']" :key="id" :value="id">
          {{ participant.name }}
        </option>
      </select>

      <div class="message-window">
        <div class="message-area">
          <ul class="message-list">
            <li v-for="(directMessage, index) in this.$store.getters['directMessages/getByUserId'](userId)" :key="index">
              <div class="content">
                <div class="arrow-white" />
                <div class="arrow-black" />

                <div class="background-white" />
                <div class="background-black" />
                <div class="text-area">
                  <div>message: {{ directMessage.message }}</div>
                  <div>type: {{ directMessage.type }}</div>
                  <div>from: {{ directMessage.fromParticipantId }}</div>
                  <div>to: {{ directMessage.toParticipantId }}</div>
                  <div>create: {{ directMessage.createdAt }}</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!-- modal -->
    <transition name="fade" v-if="showModal">
      <template>
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-container-inner">
                <div class="modal-content">
                  <div slot="content">
                    <div class="content-header">
                      <h2>DM send</h2>
                      <button class="close-btn" @click="hideModalStatus">
                        <fa-icon icon="times" />
                      </button>
                    </div>
                    <div class="boxTxt_inner">
                      <h4>DM送信テスト</h4>
                      <p>クリックしたユーザからのDMを登録します。</p>

                      <section class="inline">
                        <label>Send From:</label>
                        <span style="margin: 0 16px">{{ id }}</span>
                      </section>

                      <section class="inline">
                        <label>Send To:</label>
                        <select v-model="toId">
                          <option v-for="(participant, id) in this.$store.getters['participants/all']" :key="id" :value="id">
                            {{ participant.name }}
                          </option>
                        </select>
                      </section>

                      <section class="inline">
                        <label>message:</label>
                        <input id="dm" placeholder="送信メッセージ" v-model="dm" />
                      </section>

                      <section>
                        <button class="btn" @click="dispatchDm">Send</button>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition>

    <transition name="fade" v-if="showMoveModal">
      <template>
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-container-inner">
                <div class="modal-content">
                  <div slot="content">
                    <div class="content-header">
                      <h2>Move</h2>
                      <button class="close-btn" @click="hideModalStatus">
                        <fa-icon icon="times" />
                      </button>
                    </div>
                    <div class="boxTxt_inner">
                      <h4>ルーム移動テスト</h4>
                      <p>クリックしたユーザを別の部屋に移動します</p>

                      <section class="inline">
                        <label>Move User:</label>
                        <span style="margin: 0 16px">{{ participant.id }}</span>
                      </section>

                      <section class="inline">
                        <label>Move To:</label>
                        <input type="text" placeholder="移動先Slug" v-model="where" />
                      </section>

                      <section>
                        <button class="btn" @click="move">Move</button>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition>
  </div>
</template>

<script>
import {DirectMessage, Participant} from "socket_if"
import moment from "moment"

export default {
  name: "Socket",
  components: {},
  data: function() {
    return {
      showModal: false,
      showMoveModal: false,
      id: null,
      participant: null,
      toId: null,
      dm: null,
      userId: null,
      where: null
    }
  },
  mounted() {
    this.$socket.init()
  },
  methods: {
    download() {
      this.$download.exec("test.txt", "aaaaa\nbbbbb\nccccc", "text/plain")
    },
    hideModalStatus() {
      this.showModal = false
      this.showMoveModal = false
      this.id = null
      this.toId = null
      this.dm = null
      this.userId = null
      this.where = null
      this.messages = []
    },
    showDMModal(id) {
      console.log(id)
      this.showModal = true
      this.id = id
    },
    showMoveModalFn(participant) {
      console.log(participant)
      this.showMoveModal = true
      this.participant = participant
    },
    dispatchDm() {
      console.log("send dm")
      console.log(this.id, this.toId, this.dm)

      const message = new DirectMessage({
        message: this.dm,
        type: 1,
        fromParticipantId: this.id,
        toParticipantId: this.toId,
        createdAt: moment.now().toString()
      })

      this.$socket.dispatcher.sendDirectMessage(message)

      this.showModal = false
      this.id = null
      this.toId = null
      this.dm = null
    },
    move() {
      let sendUser = {...this.participant}
      sendUser.where = this.where
      console.log(sendUser)
      console.log(this.where)
      this.$socket.dispatcher.moveParticipant(new Participant(sendUser))

      this.showMoveModal = false
      this.participant = null
      this.where = null
    }
  }
}
</script>

<style scoped>
h2 {
  font-size: 28px;
  font-weight: bold;
  border-bottom: solid 2px #42b983;
  border-left: solid 8px #42b983;
  padding-left: 8px;
  margin: 8px 0;
}

li.participant {
  border-radius: 5px;
  box-shadow: 0 4px 15px rgba(53, 73, 94, 0.2);
  padding: 16px;
  min-width: 300px;
  margin-right: 8px;
  display: flex;
  justify-content: left;
}

section {
  margin: 24px;
}

input,
select {
  border: solid 2px #0c525d;
  border-radius: 4px;
  margin: 0 16px;
  padding: 4px;
  min-width: 250px;
}

button.btn {
  border: solid 2px #0c525d;
  border-radius: 4px;
  background: #42b983;
  padding: 4px 8px;
  color: #fff;
  font-weight: bold;
}

.modal-container {
  transform: rotate(1deg) !important;
  -moz-transform: rotate(1deg) !important;
  -webkit-transform: rotate(3deg) !important;
  background: #35495e;
  border-radius: 4px;
  padding: 2px;
}

.modal-container-inner {
  transform: rotate(-0.7deg) !important;
  -moz-transform: rotate(-0.7deg) !important;
  -webkit-transform: rotate(-1.7deg) !important;
  border-radius: 4px;
  padding: 8px;
  background: #3e9b79;
}

.modal-content {
  transform: rotate(0.3deg) !important;
  -moz-transform: rotate(0.3deg) !important;
  -webkit-transform: rotate(-1.3deg) !important;
  border-radius: 4px;
  padding: 16px;
  min-height: 350px;
  background: #fff;
}

.fa-open {
  cursor: pointer;
  margin: 4px 8px;
}

.close-btn {
  left: -16px !important;
  bottom: 0 !important;
}

section.inline {
  display: flex;
  justify-content: left;
}

.message-window {
  width: 300px;
  position: relative;
}

.message-window .message-area {
  position: absolute;
  left: 20px;
}

.message-window .message-area .content {
  position: relative;
}

.message-window .message-area .content .arrow-white {
  background-color: #fff;
  position: absolute;
  width: 25px;
  height: 25px;
  bottom: 20px;
  left: -17px;
  z-index: -20;
  clip-path: polygon(62% 43%, 100% 17%, 100% 73%, 50% 100%, 44% 56%, 0 71%, 55% 8%);
  animation-name: arrowWhiteAnimation;
  animation-duration: 1s;
  animation-iteration-count: infinite;
}

.message-window .message-area .content .arrow-black {
  background-color: #000;
  position: absolute;
  width: 28px;
  height: 20px;
  bottom: 22px;
  left: -17px;
  z-index: -10;
  clip-path: polygon(62% 43%, 100% 26%, 100% 73%, 53% 80%, 44% 56%, 0 71%, 56% 19%);
  animation-name: arrowBlackAnimation;
  animation-duration: 1s;
  animation-iteration-count: infinite;
}

.message-window .message-area .content .background-white {
  background-color: #fff;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -40;
  clip-path: polygon(6% 0, 100% 0, 90% 100%, 0 87%);
  animation-name: backgroundWhiteAnimation;
  animation-duration: 1s;
  animation-iteration-count: infinite;
}

.message-window .message-area .content .background-black {
  background-color: #000;
  position: absolute;
  width: calc(100% - 25px);
  height: calc(100% - 12px);
  margin-left: 5px;
  margin-right: 20px;
  margin-top: 5px;
  margin-bottom: 7px;
  z-index: -30;
  clip-path: polygon(6% 0, 100% 0, 95% 100%, 0 87%);
  animation-name: backgroundBlackAnimation;
  animation-duration: 1s;
  animation-iteration-count: infinite;
}

.message-window .message-area .content .text-area {
  color: #fff;
  font-size: 20px;
  margin-left: 5px;
  margin-right: 50px;
  margin-top: 5px;
  margin-bottom: 7px;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 15px;
  padding-bottom: 20px;
  line-height: 1.2em;
}

@keyframes arrowWhiteAnimation {
  0% {
    clip-path: polygon(62% 43%, 100% 17%, 100% 73%, 50% 100%, 44% 56%, 0 71%, 55% 8%);
  }
  25% {
    clip-path: polygon(62% 43%, 100% 18%, 99% 73%, 50% 99%, 44% 56%, 0 72%, 55% 8%);
  }
  50% {
    clip-path: polygon(61% 43%, 98% 17%, 100% 73%, 48% 100%, 43% 56%, 1% 71%, 56% 8%);
  }
  75% {
    clip-path: polygon(62% 44%, 100% 17%, 100% 72%, 50% 100%, 44% 58%, 0 71%, 55% 9%);
  }
  100% {
    clip-path: polygon(62% 43%, 100% 17%, 100% 73%, 50% 100%, 44% 56%, 0 71%, 55% 8%);
  }
}

@keyframes arrowBlackAnimation {
  0% {
    clip-path: polygon(62% 43%, 100% 26%, 100% 73%, 53% 80%, 44% 56%, 0 71%, 56% 19%);
  }
  25% {
    clip-path: polygon(63% 43%, 100% 26%, 98% 73%, 53% 80%, 42% 56%, 1% 71%, 56% 19%);
  }
  50% {
    clip-path: polygon(62% 44%, 100% 27%, 100% 72%, 53% 81%, 44% 57%, 0 74%, 56% 18%);
  }
  75% {
    clip-path: polygon(62% 43%, 99% 26%, 100% 73%, 54% 80%, 44% 56%, 0 71%, 57% 19%);
  }
  100% {
    clip-path: polygon(62% 43%, 100% 26%, 100% 73%, 53% 80%, 44% 56%, 0 71%, 56% 19%);
  }
}

@keyframes backgroundWhiteAnimation {
  0% {
    clip-path: polygon(6% 0, 100% 0, 90% 100%, 0 87%);
  }
  25% {
    clip-path: polygon(6% 0, 98% 1%, 90% 100%, 1% 88%);
  }
  50% {
    clip-path: polygon(6% 2%, 100% 0, 89% 100%, 0 87%);
  }
  75% {
    clip-path: polygon(6% 0, 100% 0, 90% 99%, 0 87%);
  }
  100% {
    clip-path: polygon(6% 0, 100% 0, 90% 100%, 0 87%);
  }
}

@keyframes backgroundBlackAnimation {
  0% {
    clip-path: polygon(6% 0, 100% 0, 95% 100%, 0 87%);
  }
  25% {
    clip-path: polygon(7% 0, 100% 0, 94% 100%, 0 88%);
  }
  50% {
    clip-path: polygon(6% 1%, 100% 0, 95% 99%, 0 87%);
  }
  75% {
    clip-path: polygon(6% 0, 99% 1%, 95% 100%, 1% 87%);
  }
  100% {
    clip-path: polygon(6% 0, 100% 0, 95% 100%, 0 87%);
  }
}

ul.message-list {
  padding: 48px;
  border-left: solid 8px #42b983;
  margin: 16px;
}
</style>
